"use client"

import { useTranslation } from "react-i18next"

type RelatedProductsTitleProps = {
  showRelatedLabel?: boolean
}

export default function RelatedProductsTitle({ showRelatedLabel = false }: RelatedProductsTitleProps) {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col items-center text-center mb-16">
      {showRelatedLabel && (
        <span className="text-base-regular text-gray-600 mb-6">
          {t("product.relatedProducts")}
        </span>
      )}
      <p className="text-2xl-regular text-ui-fg-base max-w-lg">
        {t("product.youMightAlsoLike")}
      </p>
    </div>
  )
}

